import { render, staticRenderFns } from "./EntradasComponent.vue?vue&type=template&id=73dabad0"
import script from "./EntradasComponent.vue?vue&type=script&lang=js"
export * from "./EntradasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports